import { Themes } from '@src/Passport.enums'
import { TTheme } from '@src/Passport.types'

export const getIconAttrs = (theme: TTheme | null = null) => {
  return {
    width: '20px',
    ...(theme === Themes.BLACK ? { filter: 'brightness(0) invert(1)' } : {}), // brightness(0) invert(1) - makes WHITE
  }
}
